export default __webpack_public_path__ + "static/media/audit.7a58e487.png";